<template>
    <div :class="[fixedNum=='notop'?'loadingWrap_noFixed':'loadingWrap']">
        <mt-spinner :size="40" type="triple-bounce"></mt-spinner>
    </div>
</template>
<script>
export default {
    name: "Loading",
    props:['fixedNum'],
    data(){
        return{
            data(){

            }
        }
    },
    mounted(){
        
    }
}
</script>
<style lang="scss" scoped>
.loadingWrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: rgba(0, 0, 0, .6 );
    display: flex;
    justify-content: center;
    align-items: center;
}

.loadingWrap_noFixed{
    width: 100%;
    height: 100%;
    position: fixed;
    top: .9rem;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: rgba(0, 0, 0, .6 );
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>